import { Avatar, Text } from "@/elements"

interface Props {
  name: string | null | undefined
  avatarInitials: string | null | undefined
  avatar80w: string | null | undefined
}

export const ClientTag: React.FC<Props> = ({ avatarInitials, name, avatar80w }) => {
  return (
    <div className="inline-block">
      <div className="flex flex-row flex-nowrap items-center space-x-2 rounded-full border border-bg-3 py-1 pl-1 pr-3">
        <Avatar size="xs" initials={avatarInitials} src={avatar80w} />
        <Text variant="body3" maxLines={1}>
          {name}
        </Text>
      </div>
    </div>
  )
}
